module.exports = __webpack_public_path__ + "static/media/JiaoYu2.afbf5855.png";